<script>
  import {onMount, onDestroy} from 'svelte'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'
  import Accordion from '../components/Accordion.svelte'
  import Chart from '../charts/ConnectedTV.svelte'
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import AnimatedBlock from '../components/AnimatedBlock.svelte'
  import ViewSource from '../components/ViewSource.svelte'

  let anim = {num: 0}, bg, st

  const images = {
    mobile: 'https://res.cloudinary.com/tanka-design/image/upload/v1617132456/VerizonMediaATV/intro-img1-mobile_aocvyf.jpg',
    desktop: 'https://res.cloudinary.com/tanka-design/image/upload/v1617132456/VerizonMediaATV/intro-img1-desktop_zedsqu.jpg'
  }

  $: num = anim.num < 1000 ? Math.round(anim.num) + 'M' : '+' + (Math.round(anim.num/100)/10) + 'B'

  onMount(() => {

    gsap.fromTo(bg, {opacity: 0, scale: 1.25},
      {
        opacity: 0.5,
        scale: 1,
        ease: 'power1.out',
        duration: 1.5,
        scrollTrigger: {
          trigger: bg,
          start: 'top 70%',
          toggleActions: 'play play play pause',
        }
      })

    const part3tl = gsap.timeline()
    part3tl.fromTo('.part3 .num',
      {opacity: 0},
      {
        opacity: 1,
        ease: 'none',
        duration: 0.5,
        onUpdate: () => {
          const pct = gsap.getProperty('.part3 .num', 'opacity')
          anim.num = Math.round(pct * 1100)
          anim = anim
        },
      }, 0)
    part3tl.fromTo('.part3 .hrs',
      {
        opacity: 0,
        y: 40
      },
      {
        opacity: 1,
        y: 0,
        ease: 'power2.out',
        duration: 0.5,
      }, 0.3)

    st = ScrollTrigger.create({
      trigger: '.part3 .num',
      start: 'top 70%',
      end: '+=300 center',
      toggleActions: 'play play play pause',
      animation: part3tl
    })
  })

  onDestroy(() => {
    st?.kill()
  })


</script>

<section class="part3 super-wide">
  <div class="content">
    <div class="stats">
      <div class="rgrid-md-1-2">
        <div class="col">
          <AnimatedTitle class="medium" style="maskup">Total CTV viewing time has increased by 1.1 billion hours year-over-year.</AnimatedTitle>
          <AnimatedBlock>
            <ViewSource color="white" id="total_ctv_1.1B_hrs">Magna Global Video Update 4Q2020</ViewSource>
          </AnimatedBlock>
        </div>
      </div>
      <div class="num-stack">
        <h1 class="num">{num}</h1>
        <h1 class="hrs large">Hours</h1>
      </div>
    </div>
  </div>
  <div class="bg">
    <picture>
      <source srcset={images.mobile} media="(max-width: 767px)" />
      <source srcset={images.desktop} media="(min-width: 768px)" />
      <img bind:this={bg} src={images.mobile} alt="Family watching TV" />
    </picture>
  </div>
</section>
<section class="part3b">
  <div class="rgrid-md-1-2 chart-wrap">
    <div class="col col1"></div>
    <div class="col col2">
      <div class="title-wrap"><AnimatedBlock><h4>US Programmatic Connected TV Video Ad Spending, 2019-2022</h4></AnimatedBlock></div>
      <Accordion id="ctv_ad_spending" expandedOnDesktop={true}>
        <Chart />
      </Accordion>
    </div>
  </div>
</section>

<style>
  .part3 {
    margin-top: 0;
    height: 740px;
    z-index: 1;
  }
  .part3 .bg {
    position: absolute;
    top: 0;
    height: 100%;
    overflow: hidden;
    background: black;
    left: 0;
    right: 0;
  }
  .content {
    height: 100%;
  }
  .part3 .bg picture {
    position: absolute;
    top: 0;
    left: 0;
  }
  .part3 .bg img,
  .part3 .bg picture {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .part3 .stats {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 75%;
    padding-top: 106px;
    z-index: 1;
    position: relative;
  }
  .part3 .num {
    font-size: 5.5rem;
    margin-bottom: 0;
  }
  .part3 .hrs {
    margin-bottom: 0;
  }
  .part3 :global(.view-source-wrap) {
    margin: 0.75rem 0 0;
  }
  .part3b {
    margin-top: 68px;
  }
  @media(max-width: 767px) {
    .chart-wrap .title-wrap {
      display: none;
    }
  }
  @media(min-width: 768px) {
    .chart-wrap :global(.accordion .title) {
      display: none;
    }
    .part3 .num {
      font-size: 8rem;
    }
    .part3 .stats {
      padding-top: calc(120px);
      height: 85%;
    }
  }
</style>